export const LINE_SERIES_COLOR = [];
export const BAR_SERIES_COLOR = [];

export const YAXIS_SPLITLINE_COLOR = {
  light: 'rgba(0,0,0,0.06)',
  dark: 'rgba(255,255,255,0.12)',
  gray: 'rgba(255,255,255,0.08)'
};

type ThemeMode = 'light' | 'dark';

type AxisTickStyle = Record<ThemeMode, Record<string, string | number>>;

const axisTickStyle: AxisTickStyle = {
  light: {
    color: '#000',
    opacity: 0.12
  },
  dark: {
    color: '#fff',
    opacity: 0.2
  }
};

// 白色背景下#000000 6%
// 黑色背景下#FFFFFF 12%
// 灰色背景下#FFFFFF 8%
const yAxisSplitLineStyle = {
  light: {
    color: '#000',
    opacity: 0.06,
    width: 1
  },
  dark: {
    color: '#fff',
    opacity: 0.12,
    width: 1
  }
};

export function getYAxisSplitLineStyle(themeMode: ThemeMode) {
  return yAxisSplitLineStyle[themeMode];
}

export function getAxisTickStyle(themeMode: ThemeMode) {
  return axisTickStyle[themeMode];
}
